import { cn } from '@/shared/lib'

export const Root = ({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) => {
  return (
    <section
      className={cn(
        'relative flex justify-between rounded-sm bg-white p-10 shadow-[0px_1px_7px_0px_rgba(0,0,0,0.15)]',
        className,
      )}
    >
      {children}
    </section>
  )
}

export const Title = ({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) => {
  return (
    <h2
      className={cn(
        'typo-title3 w-[343px] font-semibold whitespace-break-spaces text-black',
        className,
      )}
    >
      {children}
    </h2>
  )
}

export const Content = ({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) => {
  return (
    <div className={cn('w-[608px] space-y-8.5', className)}>{children}</div>
  )
}
